export const LOGO_URL = 'https://th.bing.com/th/id/OIG4.PXca30muCY4t.rvZlgAd?w=270&h=270&c=6&r=0&o=5&dpr=1.3&pid=ImgGn';

export const F1 = 'https://cdn.pixabay.com/photo/2024/07/04/20/24/data-8873303_1280.png';